import React from "react";

const NavBar = () => {
  return (
    <nav className="navbar navbar-dark bg-dark mb-3 sticky-top">
      <div className="container-fluid text-light">
        <h3 className="text-light">Sorting Visualizer</h3>
      </div>
    </nav>
  );
};

export default NavBar;
